import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PracticeTestService {
  constructor(private http: HttpClient) {}

  getStudentScore(studentId: number) {
    return this.http.get(`/api/get_student_score?student_id=${studentId}`, {
      headers: {
        Authorization: 'Bearer ' + localStorage['accessToken'],
      },
    });
  }

  getStudentTest() {
    return this.http.get('/api/student_tests', {
      headers: {
        Authorization: 'Bearer ' + localStorage['accessToken'],
      },
    });
  }

  getAllStudentTests(studentId: number, isParent: boolean, date?: string) {
    console.log(isParent);
    let studentTestsEndPoint = isParent
      ? `/api/student_all_tests?student_id=${studentId}${
          date ? `&completedBy=${date}` : ''
        }`
      : `/api/student_all_tests${date ? `?completedBy=${date}` : ''}`;
    return this.http.get(studentTestsEndPoint, {
      headers: {
        Authorization: 'Bearer ' + localStorage['accessToken'],
      },
    });
  }

  getAllStudentTestsById(studentId: number) {
    return this.http.get(`/api/student_all_tests?student_id=${studentId}`, {
      headers: {
        Authorization: 'Bearer ' + localStorage['accessToken'],
      },
    });
  }
}
